import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// Components
import ChangeStatusBtn from './ChangeStatusBtn';
import Lightbox from 'react-image-lightbox';
import WarningIcon from 'assets/images/svg/WarningIcon';
// Helpers
import { colleagueStatus, preparationTypes } from 'constants/Helpers';
// Selectors
import { getIsLoaderOpen } from 'store/app/AppSelectors';

const ProdJobsList = ({
  ordersListData,
  fetchMoreData,
  fetchFlorists,
  initialParams,
  onScreen,
  isMyTask,
}) => {
  const navigate = useNavigate();
  const [isLightBox, setIsLightBox] = useState(false);
  const [clickedImg, setClickedImg] = useState('');
  const isLoaderOpen = useSelector((state) => getIsLoaderOpen({ state }));
  const editDeviationEnabled = true;

  useEffect(() => {
    if (onScreen && !isLoaderOpen) {
      fetchMoreData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onScreen]);

  return (
    <>
      <div className="orderWrapper">
        {ordersListData?.length > 0 ? (
          <>
            {ordersListData?.map((item, i) => {
              return (
                <div className="card orderCard" key={i}>
                  <div style={{ display: 'flex', justifyContent: 'end', padding: 8 }}>
                    <div style={{ display: 'flex', gap: 3 }}>
                      <ChangeStatusBtn
                        item={item}
                        fetchMoreData={fetchMoreData}
                        fetchFlorists={fetchFlorists}
                        initialParams={initialParams}
                        details={false}
                        showAllCTA={true}
                      />
                    </div>
                  </div>
                  <div className="card-header orderHeader">
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">Production Job</h6>
                      <h6 className="order-card-desc">{item?.id}</h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">VM ID</h6>
                      <h6 className="order-card-desc">{item?.vmSerialId}</h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">BIN No</h6>
                      <h6 className="order-card-desc">{item?.binNumber}</h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">Items</h6>
                      <h6 className="order-card-desc">{item?.itemQty}</h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">Assigned by</h6>
                      <h6 className="order-card-desc">{item?.floristAssignedByDto?.name || ''}</h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">Status</h6>
                      <h6 className="order-card-desc prep-status">
                        {item?.status ? colleagueStatus[item?.status] : ''}
                      </h6>
                    </div>
                    <div className="assign-florist">
                      <h6 className="mb-0 order-card-header">Assigned to</h6>
                      <h6 className="order-card-desc">{item?.floristDto?.name || ''}</h6>
                    </div>
                    {/* <div className="statusBtn">
                      <ChangeStatusBtn
                        item={item}
                        fetchMoreData={fetchMoreData}
                        fetchFlorists={fetchFlorists}
                        initialParams={initialParams}
                        details={false}
                        showAllCTA={true}
                      />
                    </div> */}
                  </div>

                  {editDeviationEnabled && item?.preparedPreviously && item?.status !== 0 && (
                    <div className="header-disclaimer">
                      <WarningIcon />{' '}
                      <p>
                        This order was prepared once. Check with supervisor before moving ahead.
                      </p>
                    </div>
                  )}
                  <div className="card-body" onClick={() => navigate(`/jobdetails/${item?.id}`)}>
                    <div className="card-body-content">
                      <div className="card-body-left">
                        <div className="cart-list">
                          <div className="cart-item-container">
                            <div>
                              <img
                                className="product-img"
                                alt="product"
                                src={item?.productImage}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setClickedImg(item?.productImage);
                                  setIsLightBox(true);
                                }}
                              />
                            </div>
                          </div>

                          <div className="gift-wrap">
                            <h3 className="gift-wrap-txt">
                              <span>{item?.itemQty}X - </span>
                              {item?.productName}
                            </h3>
                          </div>
                        </div>
                      </div>

                      {/* <div className="card-body-left tags-left-col">
                        <div
                          className="prepType-btn"
                          style={{
                            backgroundColor: currentPrepType?.bgColor,
                          }}
                        >
                          <p
                            className=""
                            style={{
                              color: currentPrepType?.textColor,
                            }}
                          >
                            {currentPrepType?.name}
                          </p>
                        </div>
                        {editDeviationEnabled &&
                          item?.preparedPreviously &&
                          item?.preparationStatus !== 0 && (
                            <div className="prepType-btn prev-prepared-btn">
                              <p>Prepared Once</p>
                            </div>
                          )}
                      </div> */}
                    </div>
                  </div>
                </div>
              );
            })}
            {isLightBox && (
              <Lightbox mainSrc={clickedImg} onCloseRequest={() => setIsLightBox(false)} />
            )}
          </>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <h4 className="no-orders-title">No production jobs</h4>
          </div>
        )}
      </div>
    </>
  );
};

export default ProdJobsList;
